import { connect } from 'react-redux';
import Feedback from '../../../components/SignUp/components/Feedback';

function mapStateToProps(state) {
  return {
    userId: state.getIn(['user', 'userId'])
  };
}

export default connect(mapStateToProps)(Feedback);
